export const ANSWER_SELECT = 'ANSWER_SELECT';
export const UPDATE_VIEW = 'UPDATE_VIEW';
export const UPDATE_QUESTION = 'UPDATE_QUESTION';
export const RECEIVE_QUESTIONS = 'RECEIVE_QUESTIONS';
export const RESTART = 'RESTART';

export const answerSelect = index => ({
  type: ANSWER_SELECT, index
});

export const updateQuestion = ({ current, prev }) => ({
  type: UPDATE_QUESTION, current, prev
});

export const updateView = id => ({
  type: UPDATE_VIEW, id
});

export const receiveQuestions = ({ pool, beauty, themes }) => ({
  type: RECEIVE_QUESTIONS, pool, beauty, themes
});

export const restart = poolIndex => ({
  type: RESTART, poolIndex
});



// WEBPACK FOOTER //
// ./src/actions/index.js